import React, { useState } from 'react';

const Pensao = () => {
    const [rendaPagador, setRendaPagador] = useState('');
    const [custosBeneficiario, setCustosBeneficiario] = useState('');
    const [percentualPensao, setPercentualPensao] = useState('');
    const [resultado, setResultado] = useState(null);

    const calcularPensao = () => {
        if (!rendaPagador || !custosBeneficiario || !percentualPensao) {
            alert('Por favor, preencha todos os campos.');
            return;
        }

        const rendaPagadorNum = parseFloat(rendaPagador);
        const custosBeneficiarioNum = parseFloat(custosBeneficiario);
        const percentualPensaoNum = parseFloat(percentualPensao);

        if (isNaN(rendaPagadorNum) || isNaN(custosBeneficiarioNum) || isNaN(percentualPensaoNum)) {
            alert('Por favor, insira valores válidos.');
            return;
        }

        // Cálculo da pensão com base na renda do pagador e percentual definido
        const valorPensaoPercentual = (rendaPagadorNum * percentualPensaoNum) / 100;

        // Verifica se o valor calculado pelo percentual cobre as necessidades do beneficiário
        const valorFinalPensao = Math.max(valorPensaoPercentual, custosBeneficiarioNum);

        // Formatação dos valores
        const formatarValor = (valor) => `R$ ${valor.toFixed(2).replace('.', ',')}`;

        // Atualiza o resultado
        setResultado({
            valorPercentual: formatarValor(valorPensaoPercentual),
            valorFinal: formatarValor(valorFinalPensao),
        });
    };

    const limparCampos = () => {
        setRendaPagador('');
        setCustosBeneficiario('');
        setPercentualPensao('');
        setResultado(null);
    };

    return (
        <div className='container-calculo'>
            <div className='label-calculo'>
                <h1 className='titulo-calculo'>Cálculo de Pensão Alimentícia</h1>
            </div>

            <div className='label-calculo'>
                <h3 className='txt-calculo'>Renda do Pagador (mensal):</h3>
                <input
                    className='input-calculo'
                    type='number'
                    value={rendaPagador}
                    onChange={(e) => setRendaPagador(e.target.value)}
                />
            </div>

            <div className='label-calculo'>
                <h3 className='txt-calculo'>Custos do Beneficiário (mensal):</h3>
                <input
                    className='input-calculo'
                    type='number'
                    value={custosBeneficiario}
                    onChange={(e) => setCustosBeneficiario(e.target.value)}
                />
            </div>

            <div className='label-calculo'>
                <h3 className='txt-calculo'>Percentual da Renda para Pensão (%):</h3>
                <input
                    className='input-calculo'
                    type='number'
                    value={percentualPensao}
                    onChange={(e) => setPercentualPensao(e.target.value)}
                />
            </div>

            <div className="btn-container">
                <button className='btn-calculo-limpar' onClick={limparCampos}>
                    Limpar
                </button>
                <button className='btn-calculo' onClick={calcularPensao}>
                    Calcular
                </button>
            </div>
            {resultado && (<hr className='hr-separador'></hr>)}
            {resultado && (
                <div className='resultado-calculo'>
                    <h3 className='titulo-resultado'>Resultado do Cálculo de Pensão</h3>
                    <p className='txt-resultado'>Valor da Pensão (com base no percentual): {resultado.valorPercentual}</p>
                    <p className='txt-resultado'><strong>Valor Final da Pensão (considerando as necessidades): {resultado.valorFinal}</strong></p>
                </div>
            )}
        </div>
    );
};

export default Pensao;
